import { AfterViewInit, Component, Inject, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { APP_CONFIG } from 'src/app/configuration/ticket-management-portal-configuration'
import { TicketManagementPortalConfiguration } from 'src/app/configuration/ticket-management-portal-configuration.model'
import { DjangoSessionAuthenticationService, UserService } from 'src/app/services'
import { ModalsService } from 'src/app/shared/modals/modals.service'
import { ConfigurationService } from '../../services/configuration.service'
import { ClickSeatselectionHandler } from '../handlers/click-seatselection.handler'
import { LoadSeatselectionHandler } from '../handlers/load-seatselection.handler'
import { NavigationHandler } from '../handlers/navigation.handler'
import { PopoverCreateHandler } from '../handlers/popover-create.handler'
import { PopoverDestroyHandler } from '../handlers/popover-destroy.handler'
import { ColoringService } from '../services/coloring.service'
import { DVMService } from '../services/dvm.service'
import { FlowControlService } from '../services/flow-control.service'
import { PricingService } from '../services/pricing.service'
declare var require: any;

@Component({
  selector: 'app-seatselection',
  templateUrl: './seatselection.component.html',
  styleUrls: ['./seatselection.component.scss'],
  providers: [
    ClickSeatselectionHandler,
    LoadSeatselectionHandler,
    PopoverCreateHandler,
    PopoverDestroyHandler,
    NavigationHandler,
  ]
})
export class SeatSelectionComponent implements OnInit, AfterViewInit {
  planId: number;
  isFlexMode: boolean;
  upgradePlan: number;
  isSelectionAllowed: boolean;
  discardedSeats: object;
  currentMap: any;
  selectableMapsArray: Array<object>;
  subscription: Subscription;

  get selectedSeats() {
    const selectedSeats = [];
    // tslint:disable-next-line: forin
    for (const seat in this.flowControl.Basket) {
      selectedSeats.push(this.flowControl.Basket[seat]);
    }
    selectedSeats.sort((a, b) => a.price.price - b.price.price)
    return selectedSeats;
  }

  constructor(@Inject(APP_CONFIG)  public app_config: TicketManagementPortalConfiguration,
              private flowControl: FlowControlService,
              private pricing: PricingService,
              private route: ActivatedRoute,
              private router: Router,
              private userService: UserService,
              private dvmService: DVMService,
              private modals: ModalsService,
              private clickHandler: ClickSeatselectionHandler,
              private loadHandler: LoadSeatselectionHandler,
              private popoverCreateHandler: PopoverCreateHandler,
              private popoverDestroyHandler: PopoverDestroyHandler,
              private navigationHandler: NavigationHandler,
              private auth: DjangoSessionAuthenticationService,
              private configService: ConfigurationService,
              private coloring: ColoringService) {
    this.selectableMapsArray = Object.values(this.flowControl.getAllMaps());

  }

  ngAfterViewInit() {
    // this.coloring.applyInterfaceColors();
  }

  ngOnInit() {
    const smpClient = this.configService.client;
    this.userService.sendUrl(this.router.url);
    // Get parameters from URL
    this.planId = parseInt(this.route.snapshot.paramMap.get('planId'), 10);
    this.upgradePlan = parseInt(this.route.snapshot.paramMap.get('upgrade'), 10);

    this.isSelectionAllowed = true;
    this.userService.setSelectionAllowed(true);
    this.planId = parseInt(this.route.snapshot.paramMap.get('planId'), 10);
    this.flowControl.currentPlan = this.planId;
    if (this.upgradePlan) {
      this.flowControl.upgradePlan = this.upgradePlan;
      // Preview Upgrade Modal
      if ((smpClient !== 'miamimarlins' || !this.flowControl.isOpenHouse(this.planId)) && !this.flowControl.addonFlexPlax) {
        this.modals.upgradeModal();
      }
    } else {
      this.flowControl.upgradePlan = null;
      if (smpClient === 'padres' && this.flowControl.isOpenHouse(this.planId))
      {
          this.flowControl.init(this.planId);
          this.modals.openHousePlanModal();
      }
    }
   
    //DETERMINAR EL MODO (NORMAL O FLEX)
    // this.viewMode = Seteamos el modo
    // HARDCODEADO
    // twins flex are tier 4
    const customerPlan = this.userService.getCustomerPlanById(this.planId);
    if (this.flowControl.isFlexModeCheck(smpClient, customerPlan)) {
      this.flowControl.flexMode = true;
    }
    this.isFlexMode = this.flowControl.flexMode;
    this.discardedSeats = this.flowControl.discardedSeats;

    this.flowControl.maxAddons = customerPlan.addons_allowed;
    const plansInit = (plan) => {
      if (plan.transaction != null) {
        switch (plan.transaction.status) {
          case 'PH':
            this.router.navigate(['/checkout', this.flowControl.currentPlan]);
            break;
            case 'PR':
            this.router.navigate(['/summary', this.flowControl.currentPlan]);
            break;
          default:
            break;
        }
      }
    };
    if (!customerPlan) {
      this.auth.getUserLogged$().subscribe(
        userData => {
          this.userService.setUser(userData);
          if(userData) {
            this.app_config.rules.isTaxesBreakdownEnabled = userData['has_service_charge'] || false
          }
          plansInit(userData['plans']);
        },
        error => {
          // this.modals.errorModal(error.message);
          console.error(error);
        }
      );
    } else {
      plansInit(customerPlan);
    }

    this.dvmService.restartDVM();
    // this.loadCurrentMap();
    // if (!this.dvmService.isViewerSubjectInitialized) {
    //   this.dvmService.restartDVM(this.selectableMapsArray[this.flowControl.currentVenue]['venue']);
    // }
    this.pricing.init(Object.values(this.discardedSeats));
    this.pricing.setMaxPrice( JSON.parse(JSON.stringify(this.userService.getCustomerPlanById(this.planId).customer_plan_seats)));

    if (this.app_config.modals.warmWelcome) {
      this.modals.WarmWelcome();
    }
    if (this.configService.client === 'minnesotatwins') {
      // choice is tier 5, if we are not upgrading and we are not a choice, we are an open house, and we have choice available...
      if (!this.upgradePlan && customerPlan.plan.tier !== 5 && customerPlan.customer_plan_seats.length === 0) {
        if (customerPlan.plan_change_availability.filter(p => p.tier === 5).length > 0) {
          let fromChoice = false;
          // they want the "double" modal when coming from 20 plans
          if (customerPlan.plan.tier === 3) {
            fromChoice = true;
          }
          this.modals.twinsChoiceModal(fromChoice, customerPlan);
        }
      }
    }
  }


}
